var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"property-history"},[_c('Divider',{attrs:{"orientation":"left"}},[_vm._v("租售历史")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }